import { render, staticRenderFns } from "./workOrderWorkflowRoleConfig.vue?vue&type=template&id=5541bace&scoped=true"
import script from "./workOrderWorkflowRoleConfig.vue?vue&type=script&lang=js"
export * from "./workOrderWorkflowRoleConfig.vue?vue&type=script&lang=js"
import style0 from "./workOrderWorkflowRoleConfig.vue?vue&type=style&index=0&id=5541bace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5541bace",
  null
  
)

export default component.exports